import { useSelector } from 'react-redux';
import { selectData } from '../redux/reportSlice';
import { CSVLink } from "react-csv";

function ReportToolbar() {
  const exportData = useSelector(selectData);
  if (exportData.length) {
    return (<div>
      <a onClick={printReportClick} title="Print" href="/" target="_blank" role="button" className="print-icon no-print"><i className="fa fa-print fasize"></i></a>
      <CSVLink data={exportData} filename={"exportedData.csv"} className="export-icon no-print fa fa-download  fasize" target="_blank"></CSVLink>
    </div>);
  } else return null;
}

function printReportClick(e) {
  e.preventDefault();
  window.print();
}

export default ReportToolbar;